import { useCallback, useContext } from 'react';
import { FilterGroupContext } from 'components/filter/filters-next/FilterGroupContext';
import { FilterProviderContext } from 'components/filter/filters-next/FilterProvider';
import { useFiltersByKey } from 'components/filter/filters-next/useFiltersByKey';
import { ConditionalOperator, FilterGroup } from 'components/filter/types';
import { useFiltersCache } from 'contexts/useFiltersCache';
import { cloneDeep } from 'lodash';

const useUpdateFilterGroupOperator = (inner: boolean) => {
    const { cacheKey } = useContext(FilterProviderContext);
    const { groupId } = useContext(FilterGroupContext);
    const { currentGroup, filterGroups } = useFiltersByKey(cacheKey, groupId);
    const updateFilter = useFiltersCache(state => state.updateFiltersNextByKey);
    const operatorKey: keyof FilterGroup = inner ? 'innerOperator' : 'outerOperator';

    return useCallback(
        (operator: ConditionalOperator) => {
            const mutableGroups = cloneDeep(filterGroups);
            const foundIndex = mutableGroups.findIndex(f => f.id === currentGroup?.id);

            if (foundIndex !== -1) {
                const foundGroup = mutableGroups[foundIndex];
                mutableGroups[foundIndex] = {
                    ...foundGroup,
                    [operatorKey]: operator,
                };
            }

            updateFilter(cacheKey, mutableGroups);
        },
        [cacheKey, currentGroup?.id, filterGroups, operatorKey, updateFilter],
    );
};

export { useUpdateFilterGroupOperator };
